export const calculatePlacement2 = (ref, optionsCount) => {
    if (!ref?.current) return 'bottom';
    const rect = ref.current.getBoundingClientRect();

    const optionHeight = 28; // matches your padding: 8px 12px + font
    const menuPadding = 8;
    const actualMenuHeight = Math.min(
        optionsCount * optionHeight + menuPadding,
        window.innerHeight * 0.4 // cap at 30% of viewport as safety net
    );

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    return spaceBelow < actualMenuHeight && spaceAbove > spaceBelow ? 'top' : 'bottom';
};

export const calculatePlacement = (ref, optionsCount) => {
    if (!ref?.current) return 'bottom';
    const rect = ref.current.getBoundingClientRect();

    const vw = document.documentElement.clientWidth / 100;
    const optionHeight = 1.563 * vw;
    const menuPadding = 8;

    const actualMenuHeight = Math.min(
        Math.max(
            optionsCount * optionHeight + menuPadding,
            300  // React Select's default maxMenuHeight — minimum it renders when options exist
        ),
        window.innerHeight * 0.4
    );

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    return spaceBelow < actualMenuHeight && spaceAbove > spaceBelow ? 'top' : 'bottom';
};